import {useQuery} from '@tanstack/react-query';
import {WorkstreamListService} from 'client';
import {getService} from 'utilities';
import type {WorkstreamTimeframe} from 'views/workstreams/detail/workstreamTimeframe';

export function useAdminNarrativeRoot(
  timeframe: WorkstreamTimeframe,
  options?: {enabled?: boolean}
) {
  const enabled = options?.enabled ?? true;
  return useQuery({
    queryKey: ['admin', 'narrative-root', timeframe],
    queryFn: () =>
      getService(WorkstreamListService).getAdminNarrativeRootApiV1AdminWorkstreamNarrativeRootGet(
        timeframe
      ),
    enabled,
    staleTime: 60_000,
  });
}
